export default __webpack_public_path__ + "static/media/bannerMaratona.1fdc1748.png";